module.exports = __webpack_public_path__ + "img/sparkling_heart.c27a2fa3.png";